import dayjs, { dateInputFieldFormat } from '~libs/dayjs';
import { downloadCsv } from '~libs/csv';

const budgetUrl = (id: string): string => `${window.location.origin}/support-at-home/budgets/${id}`;

/**
 * Budgets that could NOT be copied (TAV-2649a). Kept as its own row shape and file rather than folded into
 * the review CSV: these budgets have no copy to report counts for, and the actionable column is the reason.
 * The url points at the SOURCE budget — that's the record whose data needs fixing before a retry.
 */
export interface BulkCopyFailureCsvRow {
  client_name: string | null;
  budget_id: string;
  budget_reference: string | null;
  reason: string;
  /** Mirrors the table's "Can Retry" column, so the exported list is as actionable as the on-screen one. */
  retryable: boolean;
}

const FAILURE_HEADERS = ['client_name', 'budget_reference', 'budget_url', 'reason', 'can_retry'];

export const exportBulkCopyFailuresCsv = (
  rows: BulkCopyFailureCsvRow[],
  fileBaseName = 'bulk-copy-not-copied',
): void => {
  const body = rows.map((row) => [
    row.client_name ?? '',
    row.budget_reference ?? '',
    budgetUrl(row.budget_id),
    row.reason,
    row.retryable ? 'yes' : 'no',
  ]);
  downloadCsv(`${fileBaseName}-${dayjs().format(dateInputFieldFormat)}.csv`, FAILURE_HEADERS, body);
};
